import { css } from '@emotion/react'
import cn from 'classnames'
import Label from '../Label'
import Row from '../IndentedRow'
import Dropdown from './Dropdown'

const flexStyle = css`
  flex: 1 0 100%;

  & > * {
    align-items: baseline;
  }
`

const FromRow = ({
  className,
  isLogging,
  mailbox,
  mailboxId,
  mailboxes,
  onMailboxClick,
  children,
}) => {
  let currentMailbox = mailbox
  if (mailboxId) currentMailbox = mailboxes.find(m => m.id === mailboxId)
  return (
    <div className={cn('grui flex', className)}>
      {children}
      <Row css={flexStyle}>
        <Label>
          {isLogging ? app.t('Mailbox') : 'From'}
          :
        </Label>
        <Dropdown
          mailbox={currentMailbox}
          mailboxes={mailboxes}
          onClick={onMailboxClick}
          className="grui ml-3"
        />
      </Row>
    </div>
  )
}

export default FromRow
